__turbopack_context__.v({
  "table": "Table-module__pUdFnW__table",
  "tableBody": "Table-module__pUdFnW__tableBody",
  "tableHeader": "Table-module__pUdFnW__tableHeader",
});
